import React from "react";

const ListOfBlogCard = ({ featured_image, title = "title", url, body, created }) => {

    const date = new Date(created);
    const month = date.getMonth() + 1; // 9
    const day = date.getDate();
    const year = date.getFullYear();
    const formattedDate = `${month}-${day}-${year}`;

    const getLastPartOfUrl = (url) => {
        const parts = url.split('/');
        return "/blog/"+parts[parts.length - 1];
    }

    return (
        <div className="flex flex-col md:flex-row py-12 gap-4">
            <img className="w-full md:w-[15vw] h-52 md:h-40 bg-cover object-cover" src={featured_image} alt={title} />
            <div className="flex flex-col">
                <a href= {getLastPartOfUrl(url)}><h3 className="text-2xl">{title}</h3></a>
                <div className="text-black line-clamp-3 mt-2" dangerouslySetInnerHTML={{ __html: body }}></div>
                <div className="flex mt-4">
                    <p className="text-black">Posted by :</p>
                    <p className="text-cyan-400">{" Fintra Editor " + formattedDate}</p>
                </div>
            </div>
        </div>
    );
};

export default ListOfBlogCard;
